import { useEffect, useState } from 'react';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { appUserRatingsService } from '../services/appUserRatingsService';
import { AppUserRatingsFilters } from '../models/appUserRatingsModels';
import {
  loadAppUserRatingsState,
  saveAppUserRatingsState,
  getDefaultFilters
} from '../utils/appUserRatingsStorage';

export { getDefaultFilters } from '../utils/appUserRatingsStorage';

export const useAppUserRatings = () => {
  const service = appUserRatingsService();
  const [state, setState] = useState(loadAppUserRatingsState);

  useEffect(() => {
    saveAppUserRatingsState(state);
  }, [state]);

  const ratingsQuery = useSuperQuery(
    () =>
      service.getRatings(
        state.page,
        state.rowsPerPage,
        state.sort.sortBy,
        state.sort.sortDir,
        state.filters
      ),
    { showSpinner: true },
    [
      state.page,
      state.rowsPerPage,
      state.sort.sortBy,
      state.sort.sortDir,
      JSON.stringify({
        ...state.filters,
        dateFrom: state.filters.dateFrom?.toISOString() ?? null,
        dateTo: state.filters.dateTo?.toISOString() ?? null
      })
    ]
  );

  const handleChangePage = (newPage: number) =>
    setState((prev) => ({ ...prev, page: newPage }));

  const handleChangeRowsPerPage = (newRowsPerPage: number) =>
    setState((prev) => ({ ...prev, rowsPerPage: newRowsPerPage, page: 1 }));

  const handleSortChange = (direction: string | null, sortBy: string) =>
    setState((prev) => ({
      ...prev,
      sort: { sortDir: direction === 'desc' ? 'DESC' : 'ASC', sortBy },
      page: 1
    }));

  const onFiltersChange = (filters: AppUserRatingsFilters) =>
    setState((prev) => ({ ...prev, filters, page: 1 }));

  const resetFilters = () =>
    setState((prev) => ({ ...prev, filters: getDefaultFilters(), page: 1 }));

  return {
    ratings: ratingsQuery.data?.docs || [],
    totalItems: ratingsQuery.data?.totalDocs || 0,
    loading: ratingsQuery.isLoading,
    page: state.page,
    rowsPerPage: state.rowsPerPage,
    filters: state.filters,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSortChange,
    onFiltersChange,
    resetFilters,
    reload: ratingsQuery.reload
  };
};
